'use strict';

//Start by defining the main module and adding the module dependencies
angular.module(ApplicationConfiguration.applicationModuleName, ApplicationConfiguration.applicationModuleVendorDependencies);

// Setting HTML5 Location Mode
angular.module(ApplicationConfiguration.applicationModuleName).config(
  [
    '$httpProvider',
    '$locationProvider',
    '$compileProvider',
    'tagsInputConfigProvider',
    function ($httpProvider, $locationProvider, $compileProvider, $tagsInputConfigProvider) {
      $locationProvider.hashPrefix('!');
      $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
      $httpProvider.defaults.headers.common["X-Request-Framework"] = 'Angular';
      $compileProvider.debugInfoEnabled(false);
		$tagsInputConfigProvider.setDefaults('tagsInput', {
			placeholder: ''
		});
    }
  ]
);

//Then define the init function for starting up the application
angular.element(document).ready(function () {

  //Fixing facebook bug with redirect
	if (window.location.hash === '#_=_') {
		window.location.hash = '!/#/projects';
	}

  //Then init the app
  angular.bootstrap(document, [ApplicationConfiguration.applicationModuleName]);
});

angular.module(ApplicationConfiguration.applicationModuleName)
// Defines the different regexes which define how variables can be identified
.constant('VARIABLE_EXPRESSIONS', [
	// ICU messages
	/\{[^\}]+?\{|\}+[^\{\}]+\{|[$%]?\{[^\{\}]+\}|\}+/g,
	// Applanga-Style, it matches these strings examples => "%{test}" OR "{test}" OR "<test>"
	/(%.*?(?=[%{ ]))+|(&lt;|<).*?(\/?&gt;|>)/g,
	// Apple-/Android-Style
	/%([a-zA-Z0-9\_\-\@\$]+(\,[a-zA-Z0-9\_\-\@]+)*(?= |$|\.|\n|\,|\)|&lt;))/g
])
// Defines which files can be uploaded to be imported
.constant('ALLOWED_IMPORT_FILE_EXTENSIONS', ['csv', 'tsv', 'ini', 'js', 'json', 'properties', 'po', 'pot', 'resw', 'resx', 'strings', 'stringsdict', 'xls', 'xlsx', 'xliff', 'xlf', 'xml', 'yaml', 'yml', 'arb', 'tmx', 'tbx', 'php'])
.constant('ALLOWED_TM_IMPORT_FILE_EXTENSIONS', ['csv', 'tsv', 'ini', 'js', 'json', 'properties', 'po', 'pot', 'resw', 'resx', 'strings', 'stringsdict', 'xls', 'xlsx', 'xliff', 'xlf', 'xml', 'yaml', 'yml', 'arb', 'tmx', 'tbx', 'php'])
.constant('DEFAULT_TAG_CATEGORIES', [{name: 'iOS',     color: '#979797', icon: '&#xf179'}, 
                                     {name: 'Android', color: '#a4c639', icon: '&#xf17b'}, 
                                     {name: 'Web',     color: '#9c27b0', icon: '&#xf0ac'}, 
                                     {name: 'Jira',    color: '#3099d5', icon: '&#xf7b1'}])
.config(['$qProvider', function($qProvider){
  $qProvider.errorOnUnhandledRejections(false);
}]);
